import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import productTileTemplate from './productTileTemplate';
import { saveRecentlyViewedCookie, extractRecentlyViewedProducts } from './recentlyViewedCookie';
import { formatProductPrices } from '../../core/helpers';

const slides_to_show_desktop = 5.4;
let center_mode_desktop = false;

const initSlider = () => {
  // Only one slider element supported per page

  const swiper = new Swiper('[data-recently-viewed-products-slider].swiper', {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: true,
    slidesPerView: 2.2,
    slidesPerGroup: 2.2,
    spaceBetween: 20,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    cssMode: false, // disabled, it doesn't set the height correctly in this case
    centeredSlides: center_mode_desktop,
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: slides_to_show_desktop,
        slidesPerGroup: Math.floor(slides_to_show_desktop),
        freeMode: false,
        navigation: {
          nextEl: '.recently-viewed-products .swiper-button-next',
          prevEl: '.recently-viewed-products .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
      },
    }
  });
};

export default () => {
  saveRecentlyViewedCookie();

  const $slider = $('[data-recently-viewed-products-slider].swiper');

  if (!$slider.length) {
    return;
  }

  let viewed_products = extractRecentlyViewedProducts();
  // console.log('viewed_products', viewed_products);

  if (!viewed_products.length) {
    $('.recently-viewed-products-section').remove();
    return;
  }

  // Create the product tiles
  try {
    const compiled = _.template(`
    <% jq.each(products, function(index) { %>${productTileTemplate()}<% }); %>
  `, {imports: { jq: $ } });
    console.log('viewed_products', viewed_products);
    viewed_products = formatProductPrices(viewed_products, true);

    const products_tiles_html = compiled({ products: viewed_products, is_lookbook: false, quickview: false, is_search: false });
  
    $slider.find('.swiper-wrapper').html(products_tiles_html);
  } catch (error) {
    console.log(error);
  }

  if (viewed_products.length < slides_to_show_desktop) {
    center_mode_desktop = false;
  }

  window.setTimeout(() => {
    initSlider();
  }, 100);
};
